import React, { useState } from 'react';
import Layout from 'components/Layout';
import SEO from 'components/Seo';
import { useRouter } from 'next/router';
import classes from './styles.module.scss';
import { Heading, Text } from '@chakra-ui/react';
import { workData } from 'data/howItWorksData';
import NextImage from 'components/NextImage';
import clsx from 'clsx';
import { workSchema } from 'data/Schema/howItWorksSchema';
import { organization } from 'data/Schema/commonSchema';
import useMediaQuery from 'hooks/useMediaQuery';
import Link from 'next/link';
import { FaChevronLeft } from 'react-icons/fa';

const HowItWorksPage = () => {
  const router = useRouter();

  const isTab = useMediaQuery('(max-width: 1000px)');
  const isMobile = useMediaQuery('(max-width: 768px)');

  const schemaCodes = [
    {
      type: 'application/ld+json',
      code: JSON.stringify(organization)
    },
    {
      type: 'application/ld+json',
      code: JSON.stringify(workSchema)
    }
  ];

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        url={router.pathname}
        title="Learn how Sikka wallet works - Sikka"
        description="Steps by step process on how to start earning money with sikka app daily with ease and refer your friends to earn more. Sign up Now to earn money."
        keywords={['Sikka', 'Sikka Wallet']}
        schemaCodes={schemaCodes}
        // image={"/assets/images/certified-orange.png"}
      />
      <section className={classes.banner}>
        <div className={classes.header}>
          {isTab && (
            <Link href={'/'}>
              <FaChevronLeft />
            </Link>
          )}
          <h1>Learn How Sikka works</h1>
        </div>
        <p>
          India’s favorite money-earning app - Sikka, is easier than you think
        </p>
      </section>
      <section className={classes.workSection}>
        {workData.map((val, step) => (
          <div className={classes.card} key={step}>
            <div className={classes.imageStep}>
              <div className={classes.step}>{step + 1}</div>
              <NextImage
                className={{ imageContainer: classes.image }}
                src={val.image}
                alt={val.title}
                title={val.title}
                fill
              />
            </div>
            <div className={classes.content}>
              {val.title && <h2>{val.title}</h2>}
              {val.content.map((item, index) => (
                <div key={index}>
                  {item.description && <p>{item.description}</p>}
                  <ul
                    className={clsx(
                      classes.list,
                      item.list && item.list.points && classes.points
                    )}
                  >
                    {item.list &&
                      item.list.items.map((listItem, itemIndex) => (
                        <li key={itemIndex}>
                          {listItem.title && (
                            <span className={classes.title}>
                              {listItem.title}
                              {' - '}
                            </span>
                          )}
                          {listItem.description}
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </Layout>
  );
};

export default HowItWorksPage;
